import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router';
import Home from './pages/Home';
import Bio from './pages/Bio';
import Blog from './pages/Blog';

import Song from './components/Song';
import Header from './components/Header';
import Footer from './components/Footer';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent } from './logEvent';

function Analytics() {
  const location = useLocation();

  useEffect(() => {
    logEvent('page_view');
  }, [location.pathname]);

  return null;
}

const root = document.getElementById('root');

ReactDOM.createRoot(root).render(
  <BrowserRouter>
    <Analytics />
    <Header />
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/bio' element={<Bio />} />
      <Route path='/blog' element={<Blog />} />
      <Route path='/song/:album/:song' element={<Song />} />
    </Routes>
    <Footer />
  </BrowserRouter>
);
